import React from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import { Font } from "@react-pdf/renderer";
import axios from "axios";
import { PDFViewer } from "@react-pdf/renderer";
import DMSansBoldFont from "../../assets/fonts/DMSans-Bold.ttf";
import DMSansRegularFont from "../../assets/fonts/DMSans-Regular.ttf";
import imageFileResizer from "react-image-file-resizer";

import {
  Document,
  Image,
  Note,
  Page,
  StyleSheet,
  Text,
  View,
  Link,
} from "@react-pdf/renderer";

import "moment-timezone";
import "moment/locale/es";
import { formatDateString } from "../../helpers/datesHelper";
import { sanitizeNombreServicioPdf } from "../../utils/pdf/sanitizeNombreServicioPdf";
import {
  cotizacionTieneClienteVinculado,
  docIdentidadClienteCotizacionPdf,
  nombreDisplayClienteCotizacionPdf,
} from "../../utils/pdf/cotizacionClientePdfDisplay";
import { useState } from "react";
import { useEffect } from "react";
import { Buffer } from "buffer";
Font.register({
  family: "DMSans-Bold",
  src: DMSansBoldFont,
});
Font.register({
  family: "DMSans-Regular",
  src: DMSansRegularFont,
});
const styles = StyleSheet.create({
  page: {
    fontFamily: "DMSans-Regular",
    fontSize: 12,
    padding: "10px",
    position: "relative",
  },
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: "10px",
    paddingTop: "100px",
  },
  subtitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: "20px",
  },
  certificateImage: {
    width: "100px",
    height: "auto",
    marginBottom: "20px",
  },
  whatHasBeenDone: {
    fontSize: 10,
    fontWeight: "semibold",
    marginBottom: "10px",
    color: "rgb(150,150,150)",
  },
  recipientName: {
    fontSize: 30,
    fontWeight: "semibold",
    marginBottom: "10px",

    color: "rgb(60,60,60)",
  },
  signature: {
    fontSize: 12,
    marginTop: "80px",
    color: "rgb(60,60,60)",
    paddingBottom: "50px",
  },
  courseName: {
    fontSize: 15,
    color: "rgb(100,100,100)",
    fontWeight: "bold",
  },
  courseInsight: {
    fontSize: 10,
    fontWeight: "semibold",
    marginTop: "15px",
    color: "rgb(150,150,150)",
  },
  pageBackground: {
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    display: "block",
    height: "100%",
    width: "100%",
  },
});

const stylesServicios = StyleSheet.create({
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColMain: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
  },
  tableCellTitle: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    fontFamily: "DMSans-Bold",
  },
});

const stylesPagos = StyleSheet.create({
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "33.333333%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },

  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
  },
  tableCellTitle: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    fontFamily: "DMSans-Bold",
  },
});

const separateString = (inputString, chunkSize) => {
  const regex = new RegExp(`.{1,${chunkSize}}`, "g");
  const parts = inputString.split("-");

  const separatedParts = parts.map((part) => part.match(regex).join(" "));
  return separatedParts.join("-");
};
const CotizacionPDFDialog = ({
  open,
  igv,
  onClose,
  title,
  descuento,
  cotizacionData,
  serviciosList,
  pagosList,
  moneda,
}) => {
  const fetchImage = async (url) => {
    if (url) {
      try {
        // Download the image
        const response = await axios.get(url, {
          responseType: "blob",
        });

        // Resize the image
        const resizedImage = await new Promise((resolve) => {
          imageFileResizer.imageFileResizer(
            response.data,
            1000, // Max width
            1000, // Max height
            "JPEG", // Output format
            100, // Quality
            0, // Rotation
            (resizedImage) => {
              resolve(resizedImage);
            },
            "base64"
          );
        });

        return `${resizedImage}`;
      } catch (error) {
        console.log("Error fetching image:", error);
        return "";
      }
    }
  };
  const [servicesListLocal, setServicesListLocal] = useState([]);

  useEffect(() => {
    const updateBase64Image = async () => {
      const updatedData = await Promise.all(
        serviciosList.map(async (e) => {
          const base64Image = await fetchImage(
            (
              e?.customDescriptionActive
                ? e?.customDescriptionText
                : e?.servicio?.preciosUnitarios.find(
                    (ser) => ser.plan.id === e.planServicio.id
                  )?.servicioProcesoClienteMedia?.url &&
                  e?.customDescriptionActive
                ? e?.customDescriptionText
                : e?.servicio?.preciosUnitarios
                    .find((ser) => ser.plan.id === e.planServicio.id)
                    ?.servicioProcesoClienteMedia?.mimeType.startsWith("image")
            )
              ? e?.customDescriptionActive
                ? e?.customDescriptionText
                : e?.servicio?.preciosUnitarios.find(
                    (ser) => ser.plan.id === e.planServicio.id
                  )?.servicioProcesoClienteMedia?.url
              : ""
          );
          return { ...e, base64Image };
        })
      );
      setServicesListLocal(updatedData);
    };

    updateBase64Image();
  }, [open]);

  const nombreClienteCabeceraDialog = nombreDisplayClienteCotizacionPdf(
    cotizacionData,
    null
  );
  const docClienteCabeceraDialog = docIdentidadClienteCotizacionPdf(cotizacionData);
  const mostrarPrefijoRucCabecera =
    cotizacionData?.tipo !== "Cotizacion" ||
    cotizacionTieneClienteVinculado(cotizacionData);

  const pdf = (
    <>
      {
        <Document>
          <Page size="A4" orientation="landscape" style={styles.page}>
            <View
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
                marginTop: "0px",
                paddingHorizontal: "20px",
                gap: "20px",
              }}
            >
              <View
                style={{
                  flexDirection: "column",
                }}
              >
                <Image
                  style={{
                    width: "100%",
                    height: "auto",
                    marginHorizontal: "auto",
                  }}
                  src={"/images/LOGO-VERSION-1-HORIZONTAL-MC.png"}
                />

                {/* <View style={{display:"flex",flexDirection:"row",justifyContent:"center",fontWeight:"extrabold"}}> <Text style={{textAlign:"center",textDecoration:"underline"}}>Monstruo Creativo</Text></View> */}
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Razon social: Monstruo Creativo SAC
                </Text>
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  RUC: 20609563258
                </Text>

                <Text
                  style={{
                    paddingVertical: "2px",
                    fontFamily: "DMSans-Bold",
                    fontSize: "10px",
                  }}
                >
                  Tipo:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.tipo}
                  </Text>
                </Text>

                <Text
                  style={{
                    paddingVertical: "2px",
                    fontFamily: "DMSans-Bold",
                    fontSize: "10px",
                  }}
                >
                  Cliente:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {nombreClienteCabeceraDialog}
                  </Text>
                </Text>

                <Text
                  style={{
                    paddingVertical: "2px",
                    fontFamily: "DMSans-Bold",
                    fontSize: "10px",
                  }}
                >
                  {mostrarPrefijoRucCabecera && "Ruc:"}{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {docClienteCabeceraDialog}
                  </Text>
                </Text>

                {cotizacionData?.tipo === "Factura" && (
                  <>
                    <Text
                      style={{
                        paddingVertical: "2px",
                        fontFamily: "DMSans-Bold",
                        fontSize: "10px",
                      }}
                    >
                      Encargado:{" "}
                      <Text
                        style={{
                          paddingVertical: "2px",
                          fontSize: "10px",
                          fontFamily: "DMSans-Regular",
                        }}
                      >
                        {cotizacionData?.cliente?.encargadoProyecto}
                      </Text>
                    </Text>

                    <Text
                      style={{
                        paddingVertical: "2px",
                        fontFamily: "DMSans-Bold",
                        fontSize: "10px",
                      }}
                    >
                      Teléfono encargado:{" "}
                      <Text
                        style={{
                          paddingVertical: "2px",
                          fontSize: "10px",
                          fontFamily: "DMSans-Regular",
                        }}
                      >
                        {cotizacionData?.cliente?.telefono}
                      </Text>
                    </Text>
                  </>
                )}
              </View>
              <View
                style={{
                  flexDirection: "column",
                  flex: 1,
                }}
              >
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  Asesor comercial:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.cotizador?.name}
                  </Text>
                </Text>
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  Teléfono:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    +51 946 966 454
                  </Text>
                </Text>
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  Correo electrónico:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.cotizador?.email}
                  </Text>
                </Text>
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  # Cotizacion:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.id}
                  </Text>
                </Text>
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  Fecha cotización:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.createdAt &&
                      formatDateString(cotizacionData?.createdAt)}
                  </Text>{" "}
                </Text>
                <Text
                  style={{ paddingVertical: "2px", fontFamily: "DMSans-Bold" }}
                >
                  {" "}
                  Válido hasta:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    {cotizacionData?.fechaCotizacionLimite &&
                      formatDateString(cotizacionData?.fechaCotizacionLimite)}
                  </Text>
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  flex: 1,
                }}
              >
                <Text
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    fontFamily: "DMSans-Bold",
                    paddingBottom: "2px",
                  }}
                >
                  N° Cuentas Monstruo Creativo
                </Text>
                {/* <View>
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Bold",
                    }}
                  >
                    Cuenta BCP Dólares:{" "}
                    <Text
                      style={{
                        paddingVertical: "2px",
                        fontSize: "10px",
                        fontFamily: "DMSans-Regular",
                      }}
                    >
                      19199944352188
                    </Text>
                  </Text>
                </View>
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta BCP Interbancaria dólares:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    00219119994435219957
                  </Text>
                </Text> */}
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta Interbank dólares:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    200-3004305598
                  </Text>
                </Text>
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta Interbank interbancaria dólares:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    003-200-003004305598-34
                  </Text>
                </Text>
                {/* <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta BCP soles:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    19195069993093
                  </Text>
                </Text>

                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta BCP interbancaria soles:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    0021919506999309354
                  </Text>
                </Text> */}
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta Interbank soles:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    200-3004305580
                  </Text>
                </Text>
                <Text
                  style={{
                    paddingVertical: "2px",
                    fontSize: "10px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Cuenta Interbank Interbancaria soles:{" "}
                  <Text
                    style={{
                      paddingVertical: "2px",
                      fontSize: "10px",
                      fontFamily: "DMSans-Regular",
                    }}
                  >
                    003-200-003004305580-32
                  </Text>
                </Text>
              </View>
            </View>

            <View style={{ padding: "10px", marginTop: "10px" }}>
              <Text
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  fontFamily: "DMSans-Bold",
                }}
              >
                Servicios de interés
              </Text>
              <View style={stylesServicios.table}>
                <View style={stylesServicios.tableRow}>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>Codigo</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>
                      Cuenta Comercial o publicitaria
                    </Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>Servicio</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>Plan</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>Cantidad</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>
                      Precio Unitario
                    </Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>Total</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>IGV</Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>
                      Fecha inicio
                    </Text>
                  </View>
                  <View style={stylesServicios.tableCol}>
                    <Text style={stylesServicios.tableCellTitle}>
                      Fecha fin
                    </Text>
                  </View>
                </View>

                {serviciosList.map((e, index) => (
                  <View key={e.id} style={stylesServicios.tableRow}>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {separateString(String(e.id), 8)}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      {/* <Text style={stylesServicios.tableCell}>{e?.servicio?.cuentaComercialPublicitariaActive ?  e?.isCuentaPublicitaria ? "Cliente" : "Agencia" : "No aplica "}</Text> */}
                      <Text style={stylesServicios.tableCell}>
                        {e?.servicio?.cuentaComercialPublicitariaActive
                          ? e?.isCuentaPublicitaria
                            ? "Cliente"
                            : "Agencia"
                          : "No aplica "}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {sanitizeNombreServicioPdf(e.servicio.name)}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {sanitizeNombreServicioPdf(e?.planServicio?.name)}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {e.numeroItems}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {cotizacionData?.moneda}{" "}
                        {e?.customPriceActive
                          ? e.customPrice
                          : e.servicio.preciosUnitarios?.find(
                              (pU) => pU.plan.id === e.planServicio.id
                            )?.precio}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {cotizacionData?.moneda}{" "}
                        {e?.customPriceActive
                          ? e.customPrice * e.numeroItems
                          : e.servicio.preciosUnitarios?.find(
                              (pU) => pU.plan.id === e.planServicio.id
                            )?.precio * e?.numeroItems}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>{e?.igv}</Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {e.fechaInicio && formatDateString(e?.fechaInicio)}
                      </Text>
                    </View>
                    <View style={stylesServicios.tableCol}>
                      <Text style={stylesServicios.tableCell}>
                        {e.fechaFin && formatDateString(e?.fechaFin)}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </Page>

          <Page size="A4" orientation="landscape" style={styles.page}>
            <View style={{ padding: "10px", marginTop: "10px" }}>
              <Text
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  fontFamily: "DMSans-Bold",
                }}
              >
                Condiciones de pago
              </Text>

              <View
                style={{ display: "flex", flexDirection: "row", columnGap: 10 }}
              >
                <View style={stylesPagos.table}>
                  <View style={stylesPagos.tableRow}>
                    <View style={stylesPagos.tableCol}>
                      <Text style={stylesPagos.tableCellTitle}>
                        Descripción
                      </Text>
                    </View>
                    <View style={stylesPagos.tableCol}>
                      <Text style={stylesPagos.tableCellTitle}>
                        Monto a Pagar
                      </Text>
                    </View>
                    <View style={stylesPagos.tableCol}>
                      <Text style={stylesPagos.tableCellTitle}>
                        Fecha limite
                      </Text>
                    </View>
                  </View>

                  {pagosList.map((e, index) => (
                    <View key={e.id} style={stylesPagos.tableRow}>
                      <View style={stylesPagos.tableCol}>
                        <Text style={stylesPagos.tableCell}>
                          {e?.descripcion}
                        </Text>
                      </View>
                      <View style={stylesPagos.tableCol}>
                        <Text style={stylesPagos.tableCell}>
                          {cotizacionData.moneda} {e.precio}
                        </Text>
                      </View>
                      <View style={stylesPagos.tableCol}>
                        <Text style={stylesPagos.tableCell}>
                          {e.fechaLimite && formatDateString(e?.fechaLimite)}
                        </Text>
                      </View>
                    </View>
                  ))}
                </View>
                <View>
                  <View
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      paddingHorizontal: "10px",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "10px",
                        fontFamily: "DMSans-Regular",
                        color: "#F64000",
                      }}
                    >
                      Subtotal: {moneda}{" "}
                      {serviciosList.reduce(
                        (acc, value) =>
                          (value.customPriceActive
                            ? value.customPrice * value.numeroItems
                            : value.servicio.preciosUnitarios?.find(
                                (pU) => pU.plan.id === value.planServicio.id
                              )?.precio * value?.numeroItems) + acc,
                        0
                      )}
                    </Text>
                  </View>
                  {descuento !== 0 && (
                    <View
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        flexDirection: "row",
                        paddingHorizontal: "10px",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: "10px",
                          fontFamily: "DMSans-Regular",
                          color: "#F64000",
                        }}
                      >
                        Descuento: - {moneda} {descuento}{" "}
                      </Text>
                    </View>
                  )}
                  <View
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      paddingHorizontal: "10px",
                      paddingTop: "5px",
                    }}
                  >
                    <Text
                      style={{
                        borderTop: "1px",
                        paddingTop: "2px",
                        fontFamily: "DMSans-Bold",
                        color: "#F64000",
                      }}
                    >
                      Total a pagar: {moneda}{" "}
                      {(pagosList.reduce((acc, value) => value.precio + acc, 0).toFixed(2))}{" "}
                    </Text>
                  </View>

                  <View
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      paddingHorizontal: "10px",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: "10px",
                        fontFamily: "DMSans-Regular",
                        color: "#616161",
                      }}
                    >
                      -- {igv ? "Sí " : "No "} incluye IGV --
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View
              style={{
                padding: "10px",
                marginTop: "15px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                borderTop: "1px",
              }}
            >
              <Text>
                Política de pagos :{" "}
                <Link src="https://monstruocreativo.com/terminos-y-condiciones">
                  Ver
                </Link>
              </Text>
              <Text>
                Política de servicio :{" "}
                <Link src="https://monstruocreativo.com/terminos-y-condiciones">
                  Ver
                </Link>
              </Text>
              <Text>
                Política de privacidad :{" "}
                <Link src="https://monstruocreativo.com/politica-de-privacidad">
                  Ver
                </Link>
              </Text>
              <Text>
                Terminos y condiciones :{" "}
                <Link src="https://monstruocreativo.com/terminos-y-condiciones">
                  Ver
                </Link>
              </Text>
            </View>
          </Page>

          <Page
            size={"A4"}
            style={{
              padding: "20px",

              fontSize: 12,
            }}
            orientation="landscape"
          >
            <View>
              <View style={{ paddingBottom: "20px" }}>
                <Text
                  style={{
                    fontSize: "20px",
                    fontFamily: "DMSans-Bold",
                  }}
                >
                  Resumen de servicios
                </Text>
              </View>

              <View style={{ padding: "0px" }}>
                {servicesListLocal.map((e, index) => (
                  <View key={e.id} style={{ paddingVertical: 20 }}>
                    <View style={{ paddingBottom: 5 }}>
                      <Text
                        style={{
                          fontSize: 17,
                          fontWeight: "light",
                          fontFamily: "DMSans-Bold",
                          textDecoration: "underline",
                        }}
                      >
                        {e.servicio?.name}
                      </Text>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row" }}>
                      <View style={{ paddingLeft: 0, width: "60%" }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontWeight: "light",
                            fontFamily: "DMSans-Bold",
                          }}
                        >
                          Descripción
                        </Text>
                        <Text style={{ fontSize: 10 }}>
                          {e?.customDescriptionActive
                            ? e?.customDescriptionText
                            : e?.servicio?.preciosUnitarios.find(
                                (ser) => ser.plan.id === e.planServicio.id
                              )?.descripcion}
                        </Text>
                      </View>

                      <View style={{ width: "40%" }}>
                        {e?.customDescriptionActive
                          ? e?.customDescriptionText
                          : e?.servicio?.preciosUnitarios.find(
                              (ser) => ser.plan.id === e.planServicio.id
                            )?.linkReferencia && (
                              <>
                                <View>
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontWeight: "light",
                                      fontFamily: "DMSans-Bold",
                                    }}
                                  >
                                    Referencia del servicio
                                  </Text>
                                </View>

                                <View>
                                  <Text
                                    style={{
                                      fontSize: 10,
                                      fontWeight: "light",
                                      fontFamily: "DMSans-Regular",
                                    }}
                                  >
                                    <Link
                                      src={
                                        e?.customDescriptionActive
                                          ? e?.customDescriptionText
                                          : e?.servicio?.preciosUnitarios.find(
                                              (ser) =>
                                                ser.plan.id ===
                                                e.planServicio.id
                                            )?.linkReferencia
                                      }
                                    >
                                      {e?.customDescriptionActive
                                        ? e?.customDescriptionText
                                        : e?.servicio?.preciosUnitarios.find(
                                            (ser) =>
                                              ser.plan.id === e.planServicio.id
                                          )?.linkReferencia}
                                    </Link>
                                  </Text>
                                </View>
                              </>
                            )}

                        <View style={{ marginTop: 5 }}>
                          <View>
                            <Text
                              style={{
                                fontSize: 12,
                                fontWeight: "light",
                                fontFamily: "DMSans-Bold",
                              }}
                            >
                              Comentarios del vendedor
                            </Text>

                            <Text
                              style={{
                                fontSize: 10,
                                fontWeight: "light",
                                fontFamily: "DMSans-Regular",
                              }}
                            >
                              {e.comentarioVendedor}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </Page>
          {cotizacionData.estado === "Exito" && (
            <>
              {servicesListLocal.map((e, index) => (
                <Page
                  key={e.id}
                  size={"A4"}
                  orientation={"portrait"}
                  style={styles.page}
                >
                  <View style={{ padding: "0px" }}>
                    <View key={e.id} style={{ paddingVertical: 20 }}>
                      <View style={{ paddingBottom: 5 }}>
                        <Text
                          style={{
                            fontSize: 17,
                            fontWeight: "light",
                            fontFamily: "DMSans-Bold",
                            textDecoration: "underline",
                          }}
                        >
                          {e.servicio?.name}
                        </Text>
                      </View>

                      <View style={{ display: "flex", flexDirection: "row" }}>
                        <View style={{ width: "80%" }}>
                          {e?.customDescriptionActive
                            ? e?.customDescriptionText
                            : e?.servicio?.preciosUnitarios.find(
                                (ser) => ser.plan.id === e.planServicio.id
                              )?.linkReferencia && (
                                <>
                                  <View>
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        fontWeight: "light",
                                        fontFamily: "DMSans-Bold",
                                      }}
                                    >
                                      Referencia del servicio
                                    </Text>
                                  </View>

                                  <View>
                                    <Text
                                      style={{
                                        fontSize: 10,
                                        fontWeight: "light",
                                        fontFamily: "DMSans-Regular",
                                      }}
                                    >
                                      <Link
                                        src={
                                          e?.customDescriptionActive
                                            ? e?.customDescriptionText
                                            : e?.servicio?.preciosUnitarios.find(
                                                (ser) =>
                                                  ser.plan.id ===
                                                  e.planServicio.id
                                              )?.linkReferencia
                                        }
                                      >
                                        {e?.customDescriptionActive
                                          ? e?.customDescriptionText
                                          : e?.servicio?.preciosUnitarios.find(
                                              (ser) =>
                                                ser.plan.id ===
                                                e.planServicio.id
                                            )?.linkReferencia}
                                      </Link>
                                    </Text>
                                  </View>
                                </>
                              )}

                          {e?.customDescriptionActive
                            ? e?.customDescriptionText
                            : e?.servicio?.preciosUnitarios.find(
                                (ser) => ser.plan.id === e.planServicio.id
                              )?.servicioProcesoClienteMedia?.url && (
                                <View style={{ marginTop: 10 }}>
                                  {e?.customDescriptionActive ? (
                                    e?.customDescriptionText
                                  ) : e?.servicio?.preciosUnitarios
                                      .find(
                                        (ser) =>
                                          ser.plan.id === e.planServicio.id
                                      )
                                      ?.servicioProcesoClienteMedia?.mimeType?.startsWith(
                                        "image"
                                      ) ? (
                                    <Image
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        marginHorizontal: "auto",
                                        borderRadius: 10,
                                      }}
                                      src={e.base64Image}
                                    />
                                  ) : (
                                    <Link
                                      src={
                                        e?.customDescriptionActive
                                          ? e?.customDescriptionText
                                          : e?.servicio?.preciosUnitarios.find(
                                              (ser) =>
                                                ser.plan.id ===
                                                e.planServicio.id
                                            )?.servicioProcesoClienteMedia?.url
                                      }
                                    >
                                      Ver archivo
                                    </Link>
                                  )}
                                </View>
                              )}
                        </View>
                      </View>
                    </View>
                  </View>
                </Page>
              ))}
            </>
          )}
        </Document>
      }
    </>
  );
  return (
    <ModalInDrawer
      className="max-w-5xl w-full"
      activeModal={open}
      onClose={onClose}
      title={title}
    >
      <PDFViewer showToolbar={true} className=" w-full h-full min-h-screen">
        {pdf}
      </PDFViewer>
    </ModalInDrawer>
  );
};

export default CotizacionPDFDialog;
